<!--
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-08 15:04:09
-->
<template>
	<taskyType :type="2" />
</template>

<script>
import taskyType from '@/components/taskyType/taskyType';
export default {
	components: {
		taskyType
	}
};
</script>

<style></style>
